import React, { useEffect, useState, useCallback} from 'react'
import { Typography, Container, Divider, Box, CircularProgress, Pagination } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import CardOrderInvoiced from '../../components/CardOrderInvoiced.tsx';
import { obter_pedidos_faturados } from '../../services/peds-api';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useAuth } from "../../context/AuthContext.tsx";
import { ptBR } from '@mui/x-date-pickers/locales';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';

const HistoricoFaturado = () => {
  const [pedidosFaturados, setPedidosFaturados] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPagina, setTotalPagina] = useState(1);
  const [filtroData, setFiltroData] = useState<Dayjs | null>(dayjs()); // dayjs() = inicia com dia atual
  const { userData } = useAuth();
  const pageSize = 12;

  const carregarPedidosFaturados = useCallback(async () => {
    try {
      setCarregando(true);
      const dataParaBusca = filtroData ? filtroData.format('YYYY-MM-DD') : '';
      const res = await obter_pedidos_faturados(userData.clI_CODIGO, dataParaBusca, paginaAtual, pageSize);

      if(res.sucesso){
        setPedidosFaturados(res.lista_pedidos_faturados);
        setTotalPagina(res.paginacao.totalPaginas);
      } else {
        setPedidosFaturados([]);
        setTotalPagina(1);
      }

    } catch (error) {
      console.error("Erro ao carregar pedidos:", error);
    } finally {
      setCarregando(false);
    }
  }, [filtroData, paginaAtual, userData.clI_CODIGO]);

  useEffect(() => {
    carregarPedidosFaturados();
  }, [carregarPedidosFaturados]);
  
  return (
    <Container maxWidth="xl">
      <Typography variant="h5" marginTop={4} marginBottom={2}>
        Histórico de Pedidos Faturados
      </Typography>
      <Divider/>

      <Box py={1.5}>
        <LocalizationProvider 
          dateAdapter={AdapterDayjs}
          adapterLocale="pt-br"
          localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
          >
          <DatePicker
            slotProps={{ textField: { size: 'small', sx: { width: 140 } } }}
            label="Filtro por data"
            format='DD/MM/YYYY' 
            value={filtroData} 
            onChange={(newValue) => {
              setPaginaAtual(1);           
              setFiltroData(newValue);
            }}
          />
        </LocalizationProvider>
      </Box>
    <Divider/>

    {carregando ? (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    ) : pedidosFaturados.length === 0 ? (
      <Typography color="textSecondary">Nenhum pedido faturado encontrado nos últimos 30 dias.</Typography>
    ) : (
      <>
        {pedidosFaturados.map((pedido) => (
          <CardOrderInvoiced pedido={pedido} key={pedido.capa.notA_NUMERO}/>
        ))}

        <Box mt={3} display="flex" justifyContent="center">
          <Pagination 
            count={totalPagina}          
            page={paginaAtual}            
            onChange={(_, value) => setPaginaAtual(value)}
            color="primary" 
          />
        </Box>
      </>
    )}

  </Container>
  )
}

export default HistoricoFaturado;
